import { render, staticRenderFns } from "./MonitoringReports.vue?vue&type=template&id=189b2421&scoped=true"
import script from "./MonitoringReports.vue?vue&type=script&lang=js"
export * from "./MonitoringReports.vue?vue&type=script&lang=js"
import style0 from "./MonitoringReports.vue?vue&type=style&index=0&id=189b2421&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b2421",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189b2421')) {
      api.createRecord('189b2421', component.options)
    } else {
      api.reload('189b2421', component.options)
    }
    module.hot.accept("./MonitoringReports.vue?vue&type=template&id=189b2421&scoped=true", function () {
      api.rerender('189b2421', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/monitoring_billing/MonitoringReports.vue"
export default component.exports